


















import { PropType } from 'vue';
import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { AdgroupFormData, CATALOG } from '@tt4b/ttam-enums';
import ALink from '@/components/common/a-link/a-link.vue';
import { StateEnum, useStore } from '@tt4b/ttam-hooks';
import { trackEvent } from './../../../../utils/index';

const name = 'ttam-audience-type-alert';
export default defineComponent({
  name,
  components: {
    ALink,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    title: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const { adgroupData } = toRefs(props);
    const goToEventSources = () => {
      const { state } = useStore();
      const aadvid = computed(() => state[StateEnum.baseInfo].value.aadvid);
      const { productPlatformId, catalogAuthorizedBc } = adgroupData.value;
      const link = `${CATALOG.eventSources}?aadvid=${aadvid.value}&id=${productPlatformId}&bc_id=${catalogAuthorizedBc}`;
      window.open(link, '_blank');
      trackEvent('module_ad_group_connect_eventsource_click');
    };
    return {
      name,
      goToEventSources,
    };
  },
});
